export default {
    data() {
        return {
            image: '',
            isChartJs: true,
        }
    },

    props: {
        isUsedOnly: {
            default: false,
            type: Boolean,
        }
    },

    mounted() {
        bus.$on('request-graph-data', title => {
            if (this.title == title) {
                bus.$emit('graph-data-response', this.title, this.chart.toBase64Image());
            }
        });
    },

    methods: {
        /**
         * Get the chart as a base64encoded image
         * @return {*}
         */
        getAsImage() {
            //this.image = this.chart.toBase64Image();
        },

        /**
         * Re-draw the chart.
         */
        redraw() {
            this.chart.destroy();
            this.draw();
        }
    }
}